import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import { colorPalette } from "@waytek/Utilities/variables";
import { css } from "styled-components";

defaultCardStyles.mainWrapper = {
    ...defaultCardStyles.mainWrapper,

    css: css`
        ${defaultCardStyles.mainWrapper?.css}

        background-color: ${colorPalette.common.global.white};
        border: solid 1px ${colorPalette.common.global.industrialTaupe};
        padding: 15px;
    `,
};

defaultCardStyles.titleText = {
    ...defaultCardStyles.titleText,

    css: css`
        margin-bottom: 16px;
    `,
};

defaultCardStyles.cardTypeImage = {
    ...defaultCardStyles.cardTypeImage,

    css: css`
        flex: 0 0 48px;
    `,
};
